import { ReactComponent as DashboardIcon } from './dashboard.svg'
import { ReactComponent as AgentsIcon } from './agents.svg'
import { ReactComponent as GoalsIcon } from './goals.svg'
import { ReactComponent as RecruitingSelectedIcon } from './recruiting_filled.svg'
import { ReactComponent as RecruitingDeselectedIcon } from './recruiting_unfilled.svg'
import { ReactComponent as SettingsIcon } from './setting.svg'
import { ReactComponent as HelpIcon } from './help.svg'
import { ReactComponent as FeedbackIcon } from './feedback.svg'
import { ReactComponent as TermsOfUseIcon } from './terms_of_use.svg'
import { ReactComponent as SignoutIcon } from './logout.svg'
import { ReactComponent as LeaderboardSelectedIcon } from './leaderboard_filled.svg'
import { ReactComponent as LeaderboardDeselectedIcon } from './leaderboard_unfilled.svg'
import { ReactComponent as LeftPanelClose } from './left_panel_close.svg'
import { ReactComponent as AnywhereUxName } from './anywhere_ux_name.svg'
import { ReactComponent as LeftNavCollapsed } from './left_nav_collapsed.svg'
import { ReactComponent as UxLogo } from './ux_logo.svg'
import { ReactComponent as LeftNavExpand } from './left_nav_expand.svg'
import { ReactComponent as DrawerArrowBack } from './drawer_arrow_back.svg'
import { ReactComponent as SvgAddComment } from './SvgAddComment.svg'
import { ReactComponent as SvgAddCommentFill } from './SvgAddCommentFill.svg'

export {
	LeaderboardSelectedIcon,
	LeaderboardDeselectedIcon,
	DashboardIcon,
	AgentsIcon,
	GoalsIcon,
	RecruitingSelectedIcon,
	RecruitingDeselectedIcon,
	SettingsIcon,
	HelpIcon,
	FeedbackIcon,
	TermsOfUseIcon,
	SignoutIcon,
	LeftPanelClose,
	AnywhereUxName,
	LeftNavCollapsed,
	UxLogo,
	LeftNavExpand,
	DrawerArrowBack,
	SvgAddComment,
	SvgAddCommentFill,
}
